<template>
    <div class="login">
        <img src="../../assets/logo200.png" alt="">
        <p>{{ text }}</p>
    </div>
</template>

<script>
    import {login} from '@/api/user'

    export default {
        data() {
            return {
                text: '登录中...'
            }
        },
        mounted() {
            let code = this.$route.query.code
            let [path, inviter] = decodeURIComponent(this.$route.query.state).split('||')
            this.$store.dispatch('Login', {code, inviter}).then(_ => {
                this.text = '登录成功，跳转中...'
                setTimeout(() => {
                    this.$router.push({path: path})
                }, 2000)
            })
        },
        computed: {},
        methods: {}
    }
</script>

<style lang="scss">
    .login {
        text-align: center;
        margin-top: 30vh;

        img {
            width: 100px;
        }
    }
</style>
